import React from "react";
import { useTheme } from "styled-components";
import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

const Svg = styled.svg`
  transform: rotate(-90deg);
  background-color: #edf8fe;
  border-radius: 50%;
`;

const Text = styled.div`
  position: absolute;
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.main.primary};
`;

const CircularProgress = ({ percent = 0, size = 44, strokeWidth = 2 }) => {
  const theme = useTheme();
  const primaryColor = theme.colors.main.primary;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  // Round to whole number and ensure it's between 0 and 100
  const roundedPercent = Math.round(Math.max(0, Math.min(100, percent)));
  const offset = circumference - (roundedPercent / 100) * circumference;

  return (
    <Wrapper style={{ width: size, height: size }}>
      <Svg width={size} height={size}>
        {/* Background Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="none"
          strokeWidth={0}
          fill="#EDF8FE"
          opacity={0.2}
        />

        {/* Progress Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={primaryColor}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </Svg>

      <Text>{roundedPercent}%</Text>
    </Wrapper>
  );
};

export default CircularProgress;
